var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"main-container__menu",class:_vm.menuClasses},_vm._l((_vm.menuItems),function(item,index){return _c('div',{key:index,staticClass:"main-container__menu__item",class:{
          active: _vm.getIsActive(item),
        },attrs:{"id":item.id},on:{"click":function($event){return _vm.onClickItem(item)}}},[_c('div',[_vm._v(" "+_vm._s(item.name)+" ")]),(item.icon)?_c('div',[_c('img',{attrs:{"src":item.icon,"alt":""}})]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }